import type { EntityType } from "@/components/filter-cards";

const ICONS: Record<EntityType, string> = {
  Individual: "person",
  Organization: "domain",
  Vessel: "directions_boat",
  Aircraft: "flight",
  Country: "public",
  Media: "article",
};

export function entityTypeIcon(type: EntityType): string {
  // Defensive fallback: if an out-of-enum value ever reaches here (an
  // un-normalized backend entity_type), return a neutral icon rather than
  // rendering `<Icon name={undefined}>`. Adapters normalize via mapEntityType,
  // so this is belt-and-suspenders.
  return (ICONS as Record<string, string>)[type] ?? "category";
}
